import Vue from "vue";
import BigNumber from 'bignumber.js'
window.BN = BigNumber
import { contract as currentContract, infura_url } from '../contract.js'
import { chunkArr, getETHPrice } from './helpers'
import allabis, { ERC20_abi, cERC20_abi, yERC20_abi, synthERC20_abi, multicall_abi, multicall_address } from '../allabis'
import * as gasPriceStore from '../components/common/gasPriceStore'
import Web3 from "web3";
import { GraphQLWrapper } from '@aragon/connect-thegraph'
import * as errorStore from '../components/common/errorStore'
import { notifyHandler } from '../init'

var cBN = (val) => new BigNumber(val);

let requiresResetAllowance = ['0xdAC17F958D2ee523a2206206994597C13D831ec7', '0x77C6E4a580c0dCE4E5c7a17d0bc077188a83A059', '0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3', '0x77C6E4a580c0dCE4E5c7a17d0bc077188a83A059']

export function approve(contract, amount, account, toContract) {
    if(!toContract) toContract = currentContract.swap_address
    return new Promise((resolve, reject) => {
                contract.methods.approve(toContract, cBN(amount).toFixed(0,1))
                .send({
                    from: account,
                    gasPrice: gasPriceStore.state.gasPriceWei,
                    gas: 100000,
                })
                .once('transactionHash', function(hash) {
                    notifyHandler(hash)
                    resolve(true)
                })
                .on('error', err => {
                    errorStore.handleError(err)
                    reject(err)
                })
                .catch(err => {
                    errorStore.handleError(err)
                    reject(err)
                });
            });
}


export function approve_to_migrate(amount, account) {
    return new Promise(resolve => {
                currentContract.old_swap_token.methods.approve(currentContract.migration_address, amount)
                .send({
                    from: account,
                    gasPrice: gasPriceStore.state.gasPriceWei,
                    gas: 100000,
                })
                .once('transactionHash', function(hash) {
                    notifyHandler(hash)
                    resolve(true);
                })
                .catch(err => {
                    errorStore.handleError(err)
                    reject(err)
                });
            });
}

export async function ensure_allowance_zap_out(amount, fromContract, toContract, infinite = false) {
    console.log(`DASFASDFASFSAFASF`);
    var default_account = currentContract.default_account
    if(!fromContract) fromContract = currentContract.swap_token;
    if(!toContract) toContract = allabis[currentContract.currentContract].deposit_address
    let allowance = 0;
    try {
        allowance = cBN(await currentContract.swap_token.methods.allowance(default_account, toContract).call())
    } catch (e) {
        console.log('ensure_allowance_zap_out: getting allowance');
        throw e;
    }

    if(!infinite) {
        if(allowance.lt(cBN(amount))) {
            if(allowance > 0) await approve(fromContract, 0, default_account, toContract)
            await approve(fromContract, amount, default_account, toContract)
        }
    }
    else {
        if(allowance.lt(currentContract.max_allowance.div(cBN(2))) && cBN(amount).gt(0)) {
            if(allowance > 0 && requiresResetAllowance.includes(fromContract._address))
                await approve(fromContract, 0, default_account, toContract)
            await approve(fromContract, currentContract.max_allowance, default_account, toContract)
        }
    }
}

export async function ensure_allowance(amounts, plain = false, contractName, N_COINS, infinite = false) {
    var default_account = currentContract.default_account
    plain = false;
    let cont = currentContract
    if(N_COINS === undefined) {
        N_COINS = currentContract.N_COINS
    }
    if(contractName !== undefined) {
        cont = currentContract.contracts[contractName]
    }
    var allowances = new Array(N_COINS);
    let coins = currentContract.coins;
    let swap = cont.swap_address;
    if(plain) {
        coins = cont.underlying_coins;
        swap = allabis[cont.currentContract].deposit_address;
    }
    let fromContract = coins
    let calls = []
    for (let i=0; i < N_COINS; i++) {
        calls.push([coins[i]._address, coins[i].methods.allowance(default_account, swap).encodeABI()])
    }
    let aggcalls = await clean_and_multi_call(calls);
    allowances = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex));
    if (!infinite) {
        // Non-infinite
        for (let i=0; i < N_COINS; i++) {
            if (cBN(allowances[i]).isLessThan(cBN(amounts[i])) && cBN(amounts[i]).gt(0)) {
                if (allowances[i] > 0 && requiresResetAllowance.includes(coins[i]._address))
                    await approve(coins[i], 0, default_account, swap);
                await approve(coins[i], amounts[i], default_account, swap);
            }
        }
    }
    else {
        // Infinite
        for (let i=0; i < N_COINS; i++) {
            if (cBN(allowances[i]).isLessThan(cont.max_allowance.div(cBN(2))) && cBN(amounts[i]).gt(0)) {
                if (allowances[i] > 0 && requiresResetAllowance.includes(coins[i]._address))
                    await approve(coins[i], 0, default_account, swap);
                await approve(coins[i], cont.max_allowance, default_account, swap);
            }
        }
    }
}

export async function ensure_underlying_allowance(i, _amount, underlying_coins = [], toContract, wrapped = false, contract) {
    if(!contract) contract = currentContract
    if(!underlying_coins.length) underlying_coins = contract.underlying_coins;
    let coins = underlying_coins
    if(wrapped) coins = contract.coins
    var default_account = currentContract.default_account
    var amount = cBN(_amount);
    let current_allowance = 0;
    try {
        current_allowance = cBN(await coins[i].methods.allowance(default_account, contract.swap._address).call());
    } catch (e) {
        console.log("ensure_underlying_allowance: getting allowance");
        throw e;
    }
    if (current_allowance.gte(amount))
        return false;
    if ((cBN(_amount).isEqualTo(currentContract.max_allowance)) & (current_allowance.isGreaterThan(currentContract.max_allowance.div(cBN(2)))))
        return false;  // It does get spent slowly, but that's ok
    if ((current_allowance.isGreaterThan(cBN(0))) & (current_allowance.isLessThan(amount)) && requiresResetAllowance.includes(coins[i]._address))
        await approve(coins[i], 0, default_account, toContract);
    return await approve(coins[i], cBN(amount).toFixed(0,1), default_account, toContract);
}

export async function approveAmount(contract, amount, account, toContract, infinite = false) {
    let current_allowance = 0;
    try {
        current_allowance = cBN(await contract.methods.allowance(account, toContract).call())
    } catch(e) {
        console.log("approveAmount: approve");
        throw e;
    }
    console.log(currentContract.max_allowance)
    console.log(current_allowance.toString(), amount.toString(), current_allowance.lt(amount))
    if(!infinite) {
        if(current_allowance.lt(amount) && amount.gt(0)) {
            if(current_allowance > 0 && requiresResetAllowance.includes(contract._address)) {
                await approve(contract, 0, account, toContract)
            }
            await approve(contract, amount, account, toContract)
        }
    }
    else {
        if(current_allowance.lt(currentContract.max_allowance.div(cBN(2))) && cBN(amount).gt(0)) {
            if(current_allowance > 0 && requiresResetAllowance.includes(contract._address))
                await approve(contract, 0, account, toContract)
            await approve(contract, currentContract.max_allowance, account, toContract)
        }
    }
}

// XXX not needed anymore
// Keeping for old withdraw, to be removed whenever the chance is
export async function ensure_token_allowance() {
    var default_account = currentContract.default_account;
    let allowance = 0;
    try {
        allowance = await currentContract.swap_token.methods.allowance(default_account, currentContract.swap_address).call();
    }catch(e){
        console.log('ensure_token_allowance: allowance');
        throw e;
    }

    if (parseInt(allowance) == 0)
        return new Promise(resolve => {
            currentContract.swap_token.methods.approve(currentContract.swap_address, cBN(currentContract.max_allowance).toFixed(0))
            .send({from: default_account})
            .once('transactionHash', function(hash) {
                notifyHandler(hash)
                resolve(true);
            })
            .catch(err => {
                errorStore.handleError(err)
            });
        })
    else
        return false;
}

export function init_menu() {
    $("div.top-menu-bar a").toArray().forEach(function(el) {
        if (el.href == window.location.href)
            el.classList.add('selected')
    })
    $('.poolsdropdown .dropdown a').toArray().forEach(function(el) {
        if(el.href.slice(0,-1) == window.location.origin)
            el.classList.add('selected')
    })
}

export async function ensure_stake_allowance(amount, stakeContract, infinite = false) {
    var default_account = currentContract.default_account;
    if(!stakeContract) stakeContract = currentContract.curveRewards
    let allow = 0;
    try {
        allow = await currentContract.swap_token.methods.allowance(default_account, stakeContract._address).call()
    } catch(e) {
        console.log('ensure_stake_allowance: allowance');
        throw e;
    }
    let allowance = cBN(allow);
    if(!infinite) {
        if(allowance.lt(amount)) {
            if(allowance.gt(0))
                await approve(currentContract.swap_token, 0, default_account, stakeContract._address)
            await approve(currentContract.swap_token, amount, default_account, stakeContract._address)
        }
    }
    else {
        if(allowance.lt(currentContract.max_allowance.div(cBN(2))) && cBN(amount).gt(0)) {
            if(allowance > 0 && requiresResetAllowance.includes(currentContract.swap_token._address))
                await approve(currentContract.swap_token, 0, default_account, stakeContract._address)
            await approve(currentContract.swap_token, amount, default_account, stakeContract._address)
        }
    }
}


export function update_rates(version = 'new', contract) {
    if(!contract) contract = currentContract
    let calls = [];
    let callscoins = []
    for (let i = 0; i < allabis[contract.currentContract].N_COINS; i++) {
        let address = allabis[contract.currentContract].coins[i]
        /*
        rate: uint256 = cERC20(self.coins[i]).exchangeRateStored()
        supply_rate: uint256 = cERC20(self.coins[i]).supplyRatePerBlock()
        old_block: uint256 = cERC20(self.coins[i]).accrualBlockNumber()
        rate += rate * supply_rate * (block.number - old_block) / 10 ** 18
        */
        //for usdt pool
        if(checkTethered(contract, i)) {
            Vue.set(contract.c_rates, i, 1 / allabis[contract.currentContract].coin_precisions[i]);
        }
        else if(['swusd', 'busd', 'susd', 'pax'].includes(contract.currentContract)) {
            if(contract.currentContract == 'susd' && i == 1) {
                calls.push(['0xeDf54bC005bc2Df0Cc6A675596e843D28b16A966', '0xbb7b8b80'])
            }
            else
                //getPricePerFullShare
                calls.push([address, '0x77c7b8fc'])
            callscoins.push({pool: 'ys', i: i})
        }
        else {
            calls.push(
                //exchangeRateStored
                [address, '0x182df0f5'],
                //supplyRatePerBlock
                [address, '0xae9d70b0'],
                //accrualBlockNumber
                [address, '0x6c540baf'],
            )
            callscoins.push({pool: 'compounds', i: i})
        }
    }
    return calls;
}
    const coinMapping = {
        "0X6B175474E89094C44DA98B954EEDEAC495271D0F": 0,
        "0XA0B86991C6218B36C1D19D4A2E9EB0CE3606EB48": 1,
        "0XDAC17F958D2EE523A2206206994597C13D831EC7": 2,
        "0X0000000000085D4780B73119B644AE5ECD22B376": 3,
    }
    export async function getYPoolTVL() {
        return await fetch(`https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=0x6b175474e89094c44da98b954eedeac495271d0f%2C0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48%2C0xdac17f958d2ee523a2206206994597c13d831ec7%2C0x0000000000085d4780B73119b644AE5ecd22b376&vs_currencies=USD`)
        .then(result => result.json())
        .then(async data => {
            const keyedCoinList = Object.keys(data).reduce((p, c) => ({...p, [c]: data[c].usd}),{});
            const coinBalances = await get_ypool_balances();
            const sumPoolCoinsUSD = Object.keys(keyedCoinList).reduce((p, coinAddress) => {
                const coinIndex = coinMapping[coinAddress.toUpperCase()];
                const balance = cBN(coinBalances[coinIndex]).multipliedBy(cBN(keyedCoinList[coinAddress]));
                return p.plus(balance);
            }, cBN(0));
            console.log('sumPoolCoinsUSD', String(sumPoolCoinsUSD));
            return sumPoolCoinsUSD;
        })
    }

    export async function getAverageCoinPrice() {
        return await fetch(`https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=0x6b175474e89094c44da98b954eedeac495271d0f%2C0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48%2C0xdac17f958d2ee523a2206206994597c13d831ec7%2C0x0000000000085d4780B73119b644AE5ecd22b376&vs_currencies=USD`)
        .then(result => result.json())
        .then(async data => {
            const keyedCoinList = Object.keys(data).reduce((p, c) => ({...p, [c]: data[c].usd}),{});
            const sumCoinsUSD = Object.keys(keyedCoinList).reduce((p, coinAddress) => {
                const price = cBN(keyedCoinList[coinAddress]);
                return p.plus(price);
            }, cBN(0));
            const avg = sumCoinsUSD.div(4); // 4 coins for swusd. need to use contract.js constants
            return avg;
        })
    }
    
    async function swrvInUsd() {
        let wrapper = new GraphQLWrapper(`https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2`);
        const query = `{tokens(where: {id: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433"}) {derivedETH }}`;
        let results = await wrapper.performQuery(query);
        const serveInEth = results.data.tokens[0].derivedETH;
        const ethInusd = await getETHPrice();
        return cBN(serveInEth).multipliedBy(cBN(ethInusd));
    }
    
    const swrv_abi = [{"constant":true,"inputs":[],"name":"rate","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function","signature":"0x2c4e722e"}];
    export async function calculateSwrvApy() {
        // RATE * PRICE / 100
        const SWRV = new currentContract.web3.eth.Contract(swrv_abi, SWRV_address)
        const currentRate = (await SWRV.methods.rate().call()) * (365 * 86400) / 10**18;
        const swerveInUsd = await swrvInUsd();
        
        console.log('serve USD Price', String(swerveInUsd.toFixed(2)));
        const swUSD_address = allabis.swusd.token_address;
    
        const gauge = "0xb4d0C929cD3A1FbDc6d57E7D3315cF0C4d6B4bFa";
        const calls = [[swUSD_address, '0x70a08231000000000000000000000000' + gauge.slice(2)]];
    
        let aggcalls = await clean_and_multi_call(calls);
        let decoded = aggcalls[1].map(hex => web3.eth.abi.decodeParameter('uint256', hex))
        const gaugeBalanceTVL = cBN(decoded[0] / 1e18);
    
        const apy = currentRate * swerveInUsd / gaugeBalanceTVL * 100;
    
        return apy;
    }

    async function get_ypool_balances() {
        const contract = allabis.swusd;
        const swap = new currentContract.web3.eth.Contract(contract.swap_abi, contract.swap_address);
        let calls = [];
        for (let i = 0; i < contract.N_COINS; i++) {
            calls.push([
                swap._address,
                swap.methods.balances(i).encodeABI(),
            ])
        }

        let aggcalls = await clean_and_multi_call(calls);
        let decoded = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex))
        return decoded.reduce((p, bal, i) => {
            const balValue = bal / contract.coin_precisions[i];
            return [...p, balValue];
        }, []);
    }

export async function update_fee_info(version = 'new', contract, update = true) {
    let web3 = currentContract.web3 || new Web3(infura_url)
    if(!contract) contract = currentContract
    var swap_abi_stats = allabis[contract.currentContract].swap_abi;
    var swap_address_stats = allabis[contract.currentContract].swap_address;
    var swap_token_stats = allabis[contract.currentContract].swap_token
    var swap_token_address = allabis[contract.currentContract].token_address
    var swap_stats = contract.swap;
    var swap_token_stats = contract.swap_token;

    var default_account = contract.default_account || '0x0000000000000000000000000000000000000000';
    let calls = [
                    //.fee()
                    [swap_address_stats, swap_stats.methods.fee().encodeABI()],
                    //.admin_fee()
                    [swap_address_stats, swap_stats.methods.admin_fee().encodeABI()],
                    //balanceOf(default_account)
                    [swap_token_address, swap_token_stats.methods.balanceOf(default_account).encodeABI()],
                    //token_supply()
                    [swap_token_address, swap_token_stats.methods.totalSupply().encodeABI()],
                    ]
    let rates_calls = update_rates(version, contract);

    let swap = new web3.eth.Contract(swap_abi_stats, swap_address_stats);
    for (let i = 0; i < allabis[contract.currentContract].N_COINS; i++) {
        let balances = swap.methods.balances(i).encodeABI();
        calls.push([swap_address_stats, balances])
    }
    calls.push(...rates_calls)
    if(['susdv2','sbtc', 'swusd', 'y'].includes(contract.currentContract) && update)
        calls.push([allabis[contract.currentContract].sCurveRewards_address, contract.curveRewards.methods.balanceOf(default_account).encodeABI()])
    if(update) {
        console.log('calling await multiInitState(calls, contract)');
        await multiInitState(calls, contract)
    }
    return calls
}

function checkTethered(contract, i) {
    return allabis[contract.currentContract].tethered && allabis[contract.currentContract].tethered[i] &&
        allabis[contract.currentContract].use_lending && !allabis[contract.currentContract].use_lending[i]
        || allabis[contract.currentContract].is_plain[i] || contract.currentContract == 'susdv2' || contract.currentContract == "swusd";
}

export async function multiInitState(calls, contract, initContracts = false) {
    let web3 = currentContract.web3 || new Web3(infura_url)
    var default_account = currentContract.default_account;
    let aggcalls;
    try {
        aggcalls = await clean_and_multi_call(calls);
    }
    catch(err) {
        console.log("error in multiInitState", JSON.stringify(calls));
        aggcalls = await clean_and_multi_call(calls.slice(1));
        aggcalls[1] = [web3.eth.abi.encodeParameter('uint256', cBN(1e18).toFixed(0)), ...aggcalls[1]]
    }
    var block = +aggcalls[0]
    //initContracts && contract.currentContract == 'compound' && i == 0 ||
    let decoded = aggcalls[1].map((hex, i) =>
        (i >= aggcalls[1].length-allabis[contract.currentContract].N_COINS*2) ? web3.eth.abi.decodeParameter('address', hex) : web3.eth.abi.decodeParameter('uint256', hex)
    )
    contract.oldBalance = 0
    if(initContracts) {
        contract.virtual_price = decoded[0] / 1e18;
        contract.A = decoded[1] / 1e18;
        contract.future_A = +decoded[2];
        contract.admin_actions_deadline = +decoded[3];
        decoded = decoded.slice(4);
    }
    if(initContracts && contract.currentContract == 'compound') {
        contract.oldBalance = decoded[0];
        decoded = decoded.slice(1);
    }
    if(initContracts && contract.currentContract == 'susdv2') {
        contract.oldBalance = decoded[0];
        contract.curveStakedBalance = decoded[1]
        decoded = decoded.slice(2);
    }
    if(initContracts && ['sbtc', 'swusd', 'y'].includes(contract.currentContract)) {
        contract.curveStakedBalance = decoded[0]
        decoded = decoded.slice(1);
    }
    if(initContracts && ['tbtc', 'ren', 'sbtc'].includes(contract.currentContract)) {
        contract.initial_A = +decoded[0];
        contract.initial_A_time = +decoded[1];
        contract.future_A_time = +decoded[2];
        decoded = decoded.slice(3)
    }
    contract.fee = decoded[0] / 1e10;
    contract.admin_fee = decoded[1] / 1e10;
    var token_balance = decoded[2]
    var token_supply = decoded[3]
    contract.totalBalance = token_balance
    contract.totalSupply = token_supply
    let ratesDecoded = decoded.slice(4+allabis[contract.currentContract].N_COINS)
    if(initContracts) {
        let contractsDecoded = decoded.slice(-allabis[contract.currentContract].N_COINS*2)
        chunkArr(contractsDecoded, 2).map((v, i) => {
            var addr = v[0];
            var underlying_addr = v[1];
            let coin_abi = cERC20_abi
            var underlying_addr = v[1];
            let underlying_abi = ERC20_abi
            if(contract.currentContract == 'susdv2' && i == 3 || contract.currentContract == 'sbtc' && i == 2) {
                coin_abi = synthERC20_abi
                underlying_abi = synthERC20_abi
            }
            if(['swusd', 'busd', 'susd', 'pax'].includes(contract.currentContract)) coin_abi = yERC20_abi
            contract.coins.push(new web3.eth.Contract(coin_abi, addr));
            contract.underlying_coins.push(new web3.eth.Contract(underlying_abi, underlying_addr));
        })
        window[contract.currentContract].coins = contract.coins
        window[contract.currentContract].underlying_coins = contract.underlying_coins
        ratesDecoded = decoded.slice(4+allabis[contract.currentContract].N_COINS, decoded.length-allabis[contract.currentContract].N_COINS*2)
    }


    if(['swusd', 'busd', 'susd', 'pax'].includes(contract.currentContract)) {
        ratesDecoded.map((v, i) => {
            if(checkTethered(contract, i)) {
                Vue.set(contract.c_rates, i, 1 / allabis[contract.currentContract].coin_precisions[i]);
            }
            else {
                let rate = v / 1e18 / allabis[contract.currentContract].coin_precisions[i]
                if(contract.currentContract == 'susd' && i == 1) rate =  v / 1e36
                Vue.set(contract.c_rates, i, rate)
            }
        })
    }
    else {
        chunkArr(ratesDecoded ,3).map((v, i) => {
            if(checkTethered(contract, i) || contract.currentContract == 'susdv2') {
                Vue.set(contract.c_rates, i, 1 / allabis[contract.currentContract].coin_precisions[i]);
            }
            else {
                let rate = +v[0] / 1e18 / allabis[contract.currentContract].coin_precisions[i]
                let supply_rate = +v[1]
                let old_block = +v[2]
                Vue.set(contract.c_rates, i, rate * (1 + supply_rate * (block - old_block) / 1e18))
            }
        })
    }

    let balances = []
    currentContract.total = 0;

    let balancesDecoded = decoded.slice(4, 4+allabis[contract.currentContract].N_COINS)
    balancesDecoded.forEach((balance, i) => {
        Vue.set(contract.balances, i, +balance)
        balances[i] = +balance;
        Vue.set(contract.bal_info, i, balances[i] * contract.c_rates[i]);
        contract.total += balances[i] * contract.c_rates[i];
    })

    if(!initContracts && ['susdv2', 'sbtc', 'swusd', 'y'].includes(contract.currentContract))
        contract.curveStakedBalance = decoded[decoded.length-1]

    if (default_account) {
        if (token_balance > 0) {
            contract.totalShare = 0;
            for (let i=0; i < contract.N_COINS; i++) {
                var val = balances[i] * contract.c_rates[i] * token_balance / token_supply;
                contract.totalShare += val;
                Vue.set(contract.l_info, i, val)
            }
            contract.usdShare = token_balance * contract.virtual_price / 1e18;
            contract.showShares = true;
        }
        else {
            contract.totalShare = 0;
            contract.usdShare = 0
            contract.showShares = false;
            //no need to set other values as v-show check is done based on totalShare
        }

        contract.totalStake = 0;
        if(contract.curveStakedBalance > 0) {
            for (let i=0; i < contract.N_COINS; i++) {
                var val = balances[i] * contract.c_rates[i] * contract.curveStakedBalance / token_supply;
                Vue.set(contract.staked_info, i, val)
                contract.totalStake += val;
            }
            contract.usdStake = contract.curveStakedBalance * contract.virtual_price / 1e18;
        }
    }
}

export async function handle_migrate_new(page) {
    var default_account = currentContract.default_account
    let migration = new web3.eth.Contract(allabis.compound.migration_abi, currentContract.migration_address);
    let old_balance = 0;
    try {
        old_balance = await currentContract.old_swap_token.methods.balanceOf(default_account).call();
    } catch(e) {
        console.log('handle_migrate_new: balanceOf');
        throw e;
    }
    let allow = 0;
    try {
        allow = await currentContract.old_swap_token.methods.allowance(default_account, currentContract.migration_address).call()
    } catch(e) {
        console.log('ensure_stake_allowance: allowance');
        throw e;
    }
    var allowance = parseInt(allow);
    if(allowance < old_balance) {
        if (allowance > 0)
            await approve_to_migrate(0, default_account);
        await approve_to_migrate(old_balance, default_account);
    }
    await migration.methods.migrate().send({
        from: default_account,
        gasPrice: gasPriceStore.state.gasPriceWei,
        gas: 1500000,
    })
    .once('transactionHash', hash => {
        notifyHandler(hash)
    })
    .catch(err => {
        errorStore.handleError(err)
    });

    await update_balances();
    update_fee_info(page);
}

export async function calc_slippage(values, deposit, zap_values, to_currency) {
     //var real_values = [...$("[id^=currency_]")].map((x,i) => +($(x).val()));
     values = values.map(v => v || 0)
     let slippage = 0;
     var real_values = Array(currentContract.N_COINS).fill(0)
     let calls = [
         [currentContract.swap._address ,currentContract.swap.methods.get_virtual_price().encodeABI()],
     ]
     if(to_currency !== undefined) {
         let precision = allabis[currentContract.currentContract].coin_precisions[to_currency]
         real_values[to_currency] = zap_values[to_currency].div(precision)
         zap_values[to_currency] = zap_values[to_currency].times(1e18/precision)
         var Sr = zap_values[to_currency]
         zap_values[to_currency] = zap_values[to_currency].div(1e18).div(currentContract.c_rates[to_currency]).toFixed(0);
         calls.push([currentContract.swap._address, currentContract.swap.methods.calc_token_amount(zap_values, to_currency).encodeABI()])
     }
     else {
         real_values = values.map(v=>+v);
         var Sr = real_values.reduce((a,b) => a+b, 0);

         var values = real_values.map((x,i) => cBN(Math.floor(x / currentContract.c_rates[i]).toString()).toFixed(0,1));
         calls.push([currentContract.swap._address, currentContract.swap.methods.calc_token_amount(values, deposit).encodeABI()])
     }
     calls.push(...[...Array(currentContract.N_COINS).keys()].map(i => [currentContract.swap._address, currentContract.swap.methods.balances(i).encodeABI()]))
     let aggcalls = await clean_and_multi_call(calls);
     let decoded = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex))
     let [virtual_price, token_amount, ...balances] = decoded
     let Sv = +virtual_price * (+token_amount) / 1e36;
     for(let i = 0; i < currentContract.N_COINS; i++) {
         let coin_balance = +balances[i] * currentContract.c_rates[i];
         if(!deposit) {
             if(coin_balance < real_values[i]) {
                 currentContract.showNoBalance = true;
                 currentContract.noBalanceCoin = i;
             }
             else
                 currentContract.showNoBalance = false;
         }
     }
     if (deposit)
         slippage = Sv / Sr
     else if(to_currency === undefined) {
         slippage = Sr / Sv;
     }
     else
         slippage = Sr / (Sv * 1e18)
     slippage = slippage - 1;
     slippage = slippage || 0
     console.log(slippage)
     currentContract.slippage = slippage;
     currentContract.showSlippage = true;
}

export async function setTimeout(timeout) {
    return new Promise(resolve => setTimeout(resolve, timeout))
}

export async function clean_and_multi_call(calls, pending = false) {
    let retVals;
    let fullRetvals = [];
    const newCalls = calls.reduce((p, c, i) => {
      const supported = isSupported(c[0]);
      fullRetvals[i] = supported;
      if (supported) {
          p.push(c)
      }
      return p;
    }, []);
    try {
        const multicall = new web3.eth.Contract(multicall_abi, multicall_address);
      retVals = await pending
        ? await multicall.methods.aggregate(newCalls).call(undefined, "pending")
        : await multicall.methods.aggregate(newCalls).call();
    } catch (e) {
      console.log("clean_and_multi_call: error has occured", JSON.stringify(newCalls));
      throw e;
    }
    let clonedRetVals = retVals[1].slice();
    let filledInRetvals = [];
    fullRetvals.forEach((value, index) => {
      if (value) {
          filledInRetvals[index] = clonedRetVals.shift();
      }
    });
    retVals[1] = filledInRetvals;
    retVals.returnData = filledInRetvals;
    return retVals;
  }


const supported = [
    '0x77C6E4a580c0dCE4E5c7a17d0bc077188a83A059',
    '0x329239599afB305DA0A2eC69c58F8a6697F9F88d',
    '0xa746c67eB7915Fa832a4C2076D403D4B68085431',
    '0x0759C82A69f3DD01c37433897f12c92AE320a255',
    '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    '0x0000000000085d4780B73119b644AE5ecd22b376',
    '0x86aE6E4C4D0AA345446538a5a4158609DF6BcCD3',
    '0x0546086d8eDF7cf1A2ab090390435978b1c8E2a1',
    '0x87Cd22EccC6ffDa7534f50534F48D26aB1765d20',
    '0xa77fe4E022bE1E7b6502A20e4BE4566f7104aC55',
    '0xaA8d5F6A7747C2c6C4149e1A06eb1BFb847D6dE2',
    '0x45A22c7c3192bEC1bB92A4bE9db7128db9c5a097',
    '0xDFF7beb0cBf54D6553E4702Ae0FfA60718822478',
    '0x9ED6314706EC707DaE9BDAeeE9A14Cb6E3151CBE',
    '0x5daDBf4ed01cbA1aFd990518443033863C6e3FD8',
    '0xCcE356A37930e075921b486C746Ba8ed6EBCF172',
    '0x125Ed42cCdf7fB13eA1439B9D4c6745501b680c0',
    '0xb4d0C929cD3A1FbDc6d57E7D3315cF0C4d6B4bFa',
    '0x2c988c3974AD7E604E276AE0294a7228DEf67974',
    '0x2638d2680ab4914126Ee05b9C5EE95bac311A95e',
    '0x0C4d90ca69104B4cb937fB21c8533c29554AE32c',
    '0xe5e7DdADD563018b0E692C1524b60b754FBD7f02',
    '0xB8BAa0e4287890a5F79863aB62b7F175ceCbD433',
    '0x06769D95670916d00899327c13a99debDb6144AD',
    '0x07028a4f0a45Dba9f3f982d8D2014909BB84a43A',
    '0xb76700Be45BE8450D432859d8A153565d28e069C',
]
function isSupported(address) {
    return supported.includes(address)
}

export let liquiditygauge_abi = [{"name": "Deposit", "inputs": [{"type": "address", "name": "provider", "indexed": true}, {"type": "uint256", "name": "value", "indexed": false}], "anonymous": false, "type": "event"}, {"name": "Withdraw", "inputs": [{"type": "address", "name": "provider", "indexed": true}, {"type": "uint256", "name": "value", "indexed": false}], "anonymous": false, "type": "event"}, {"name": "UpdateLiquidityLimit", "inputs": [{"type": "address", "name": "user", "indexed": false}, {"type": "uint256", "name": "original_balance", "indexed": false}, {"type": "uint256", "name": "original_supply", "indexed": false}, {"type": "uint256", "name": "working_balance", "indexed": false}, {"type": "uint256", "name": "working_supply", "indexed": false}], "anonymous": false, "type": "event"}, {"outputs": [], "inputs": [{"type": "address", "name": "lp_addr"}, {"type": "address", "name": "_minter"}], "stateMutability": "nonpayable", "type": "constructor"}, {"name": "user_checkpoint", "outputs": [{"type": "bool", "name": ""}], "inputs": [{"type": "address", "name": "addr"}], "stateMutability": "nonpayable", "type": "function", "gas": 2079152}, {"name": "claimable_tokens", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "address", "name": "addr"}], "stateMutability": "view", "type": "function", "gas": 1998318}, {"name": "claimable_reward", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "address", "name": "addr"}], "stateMutability": "view", "type": "function", "gas": 1998318}, {"name": "kick", "outputs": [], "inputs": [{"type": "address", "name": "addr"}], "stateMutability": "nonpayable", "type": "function", "gas": 2084532}, {"name": "set_approve_deposit", "outputs": [], "inputs": [{"type": "address", "name": "addr"}, {"type": "bool", "name": "can_deposit"}], "stateMutability": "nonpayable", "type": "function", "gas": 35766}, {"name": "deposit", "outputs": [], "inputs": [{"type": "uint256", "name": "_value"}], "stateMutability": "nonpayable", "type": "function"}, {"name": "deposit", "outputs": [], "inputs": [{"type": "uint256", "name": "_value"}, {"type": "address", "name": "addr"}], "stateMutability": "nonpayable", "type": "function"}, {"name": "withdraw", "outputs": [], "inputs": [{"type": "uint256", "name": "_value"}], "stateMutability": "nonpayable", "type": "function", "gas": 2208318}, {"name": "claim_rewards", "outputs": [], "inputs": [{"type": "address", "name": "addr"}], "stateMutability": "nonpayable", "type": "function"}, {"name": "integrate_checkpoint", "outputs": [{"type": "uint256", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 2297}, {"name": "minter", "outputs": [{"type": "address", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1421}, {"name": "crv_token", "outputs": [{"type": "address", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1451}, {"name": "lp_token", "outputs": [{"type": "address", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1481}, {"name": "controller", "outputs": [{"type": "address", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1511}, {"name": "voting_escrow", "outputs": [{"type": "address", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1541}, {"name": "balanceOf", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "address", "name": "arg0"}], "stateMutability": "view", "type": "function", "gas": 1725}, {"name": "totalSupply", "outputs": [{"type": "uint256", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1601}, {"name": "future_epoch_time", "outputs": [{"type": "uint256", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1631}, {"name": "approved_to_deposit", "outputs": [{"type": "bool", "name": ""}], "inputs": [{"type": "address", "name": "arg0"}, {"type": "address", "name": "arg1"}], "stateMutability": "view", "type": "function", "gas": 1969}, {"name": "working_balances", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "address", "name": "arg0"}], "stateMutability": "view", "type": "function", "gas": 1845}, {"name": "working_supply", "outputs": [{"type": "uint256", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1721}, {"name": "period", "outputs": [{"type": "int128", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1751}, {"name": "period_timestamp", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "uint256", "name": "arg0"}], "stateMutability": "view", "type": "function", "gas": 1890}, {"name": "integrate_inv_supply", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "uint256", "name": "arg0"}], "stateMutability": "view", "type": "function", "gas": 1920}, {"name": "integrate_inv_supply_of", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "address", "name": "arg0"}], "stateMutability": "view", "type": "function", "gas": 1995}, {"name": "integrate_checkpoint_of", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "address", "name": "arg0"}], "stateMutability": "view", "type": "function", "gas": 2025}, {"name": "integrate_fraction", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "address", "name": "arg0"}], "stateMutability": "view", "type": "function", "gas": 2055}, {"name": "inflation_rate", "outputs": [{"type": "uint256", "name": ""}], "inputs": [], "stateMutability": "view", "type": "function", "gas": 1931}, {"name": "claimed_rewards_for", "outputs": [{"type": "uint256", "name": ""}], "inputs": [{"type": "address", "name": "arg0"}], "stateMutability": "view", "type": "function", "gas": 2355}]
export let votingescrow_abi = [{"name":"CommitOwnership","inputs":[{"type":"address","name":"admin","indexed":false}],"anonymous":false,"type":"event"},{"name":"ApplyOwnership","inputs":[{"type":"address","name":"admin","indexed":false}],"anonymous":false,"type":"event"},{"name":"Deposit","inputs":[{"type":"address","name":"provider","indexed":true},{"type":"uint256","name":"value","indexed":false},{"type":"uint256","name":"locktime","indexed":true},{"type":"int128","name":"type","indexed":false},{"type":"uint256","name":"ts","indexed":false}],"anonymous":false,"type":"event"},{"name":"Withdraw","inputs":[{"type":"address","name":"provider","indexed":true},{"type":"uint256","name":"value","indexed":false},{"type":"uint256","name":"ts","indexed":false}],"anonymous":false,"type":"event"},{"name":"Supply","inputs":[{"type":"uint256","name":"prevSupply","indexed":false},{"type":"uint256","name":"supply","indexed":false}],"anonymous":false,"type":"event"},{"outputs":[],"inputs":[{"type":"address","name":"token_addr"},{"type":"string","name":"_name"},{"type":"string","name":"_symbol"},{"type":"string","name":"_version"}],"stateMutability":"nonpayable","type":"constructor"},{"name":"commit_transfer_ownership","outputs":[],"inputs":[{"type":"address","name":"addr"}],"stateMutability":"nonpayable","type":"function","gas":37597},{"name":"apply_transfer_ownership","outputs":[],"inputs":[],"stateMutability":"nonpayable","type":"function","gas":38497},{"name":"commit_smart_wallet_checker","outputs":[],"inputs":[{"type":"address","name":"addr"}],"stateMutability":"nonpayable","type":"function","gas":36307},{"name":"apply_smart_wallet_checker","outputs":[],"inputs":[],"stateMutability":"nonpayable","type":"function","gas":37095},{"name":"get_last_user_slope","outputs":[{"type":"int128","name":""}],"inputs":[{"type":"address","name":"addr"}],"stateMutability":"view","type":"function","gas":2569},{"name":"user_point_history__ts","outputs":[{"type":"uint256","name":""}],"inputs":[{"type":"address","name":"_addr"},{"type":"uint256","name":"_idx"}],"stateMutability":"view","type":"function","gas":1672},{"name":"locked__end","outputs":[{"type":"uint256","name":""}],"inputs":[{"type":"address","name":"_addr"}],"stateMutability":"view","type":"function","gas":1593},{"name":"checkpoint","outputs":[],"inputs":[],"stateMutability":"nonpayable","type":"function","gas":37052342},{"name":"deposit_for","outputs":[],"inputs":[{"type":"address","name":"_addr"},{"type":"uint256","name":"_value"}],"stateMutability":"nonpayable","type":"function","gas":74279891},{"name":"create_lock","outputs":[],"inputs":[{"type":"uint256","name":"_value"},{"type":"uint256","name":"_unlock_time"}],"stateMutability":"nonpayable","type":"function","gas":74281465},{"name":"increase_amount","outputs":[],"inputs":[{"type":"uint256","name":"_value"}],"stateMutability":"nonpayable","type":"function","gas":74280830},{"name":"increase_unlock_time","outputs":[],"inputs":[{"type":"uint256","name":"_unlock_time"}],"stateMutability":"nonpayable","type":"function","gas":74281578},{"name":"withdraw","outputs":[],"inputs":[],"stateMutability":"nonpayable","type":"function","gas":37223566},{"name":"balanceOf","outputs":[{"type":"uint256","name":""}],"inputs":[{"type":"address","name":"addr"}],"stateMutability":"view","type":"function"},{"name":"balanceOf","outputs":[{"type":"uint256","name":""}],"inputs":[{"type":"address","name":"addr"},{"type":"uint256","name":"_t"}],"stateMutability":"view","type":"function"},{"name":"balanceOfAt","outputs":[{"type":"uint256","name":""}],"inputs":[{"type":"address","name":"addr"},{"type":"uint256","name":"_block"}],"stateMutability":"view","type":"function","gas":514333},{"name":"totalSupply","outputs":[{"type":"uint256","name":""}],"inputs":[],"stateMutability":"view","type":"function"},{"name":"totalSupply","outputs":[{"type":"uint256","name":""}],"inputs":[{"type":"uint256","name":"t"}],"stateMutability":"view","type":"function"},{"name":"totalSupplyAt","outputs":[{"type":"uint256","name":""}],"inputs":[{"type":"uint256","name":"_block"}],"stateMutability":"view","type":"function","gas":812560},{"name":"changeController","outputs":[],"inputs":[{"type":"address","name":"_newController"}],"stateMutability":"nonpayable","type":"function","gas":36907},{"name":"token","outputs":[{"type":"address","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":1841},{"name":"supply","outputs":[{"type":"uint256","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":1871},{"name":"locked","outputs":[{"type":"int128","name":"amount"},{"type":"uint256","name":"end"}],"inputs":[{"type":"address","name":"arg0"}],"stateMutability":"view","type":"function","gas":3359},{"name":"epoch","outputs":[{"type":"uint256","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":1931},{"name":"point_history","outputs":[{"type":"int128","name":"bias"},{"type":"int128","name":"slope"},{"type":"uint256","name":"ts"},{"type":"uint256","name":"blk"}],"inputs":[{"type":"uint256","name":"arg0"}],"stateMutability":"view","type":"function","gas":5550},{"name":"user_point_history","outputs":[{"type":"int128","name":"bias"},{"type":"int128","name":"slope"},{"type":"uint256","name":"ts"},{"type":"uint256","name":"blk"}],"inputs":[{"type":"address","name":"arg0"},{"type":"uint256","name":"arg1"}],"stateMutability":"view","type":"function","gas":6079},{"name":"user_point_epoch","outputs":[{"type":"uint256","name":""}],"inputs":[{"type":"address","name":"arg0"}],"stateMutability":"view","type":"function","gas":2175},{"name":"slope_changes","outputs":[{"type":"int128","name":""}],"inputs":[{"type":"uint256","name":"arg0"}],"stateMutability":"view","type":"function","gas":2166},{"name":"controller","outputs":[{"type":"address","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":2081},{"name":"transfersEnabled","outputs":[{"type":"bool","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":2111},{"name":"name","outputs":[{"type":"string","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":8543},{"name":"symbol","outputs":[{"type":"string","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":7596},{"name":"version","outputs":[{"type":"string","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":7626},{"name":"decimals","outputs":[{"type":"uint256","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":2231},{"name":"future_smart_wallet_checker","outputs":[{"type":"address","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":2261},{"name":"smart_wallet_checker","outputs":[{"type":"address","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":2291},{"name":"admin","outputs":[{"type":"address","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":2321},{"name":"future_admin","outputs":[{"type":"address","name":""}],"inputs":[],"stateMutability":"view","type":"function","gas":2351}]
export let SWRV_address = '0xB8BAa0e4287890a5F79863aB62b7F175ceCbD433'

export async function getUserBoostValue(estTimeLock = null) {
    const userAddress = currentContract.default_account || '0x0000000000000000000000000000000000000000';
    // gauge address
    const gauge = new web3.eth.Contract(liquiditygauge_abi, "0xb4d0C929cD3A1FbDc6d57E7D3315cF0C4d6B4bFa");
    const gaugeBalance = await gauge.methods.balanceOf(userAddress).call();
    const votingEscrow = new currentContract.web3.eth.Contract(votingescrow_abi, '0xe5e7DdADD563018b0E692C1524b60b754FBD7f02')
    const SWRV = new currentContract.web3.eth.Contract(ERC20_abi, SWRV_address)
    const mySWRV = (await SWRV.methods.balanceOf(userAddress).call() / 1e18).toFixed(2)
    const myveSWRV = (await votingEscrow.methods.balanceOf(userAddress).call() / 1e18).toFixed(2);
    const poolLiquidity = await gauge.methods.totalSupply().call();
    const totalveSWRV = (await votingEscrow.methods.totalSupply().call() / 1e18).toFixed(2);

    const Indexes = {
        BALANCE_OF: 0,
        VOTING_TOTAL_SUPPLY: 1,
        PERIOD_TIMESTAMP: 2,
        WORKING_BALANCE: 3,
        WORKING_SUPPLY: 4,
        GAUGE_TOTAL_SUPPLY: 5,
        TIME_LOCK_END: 6
    };
    let calls = [
        [votingEscrow._address, votingEscrow.methods.balanceOf(userAddress).encodeABI()],
        [votingEscrow._address, votingEscrow.methods.totalSupply().encodeABI()],
        [gauge._address, gauge.methods.period_timestamp(0).encodeABI()],
        [gauge._address, gauge.methods.working_balances(userAddress).encodeABI()],
        [gauge._address, gauge.methods.working_supply().encodeABI()],
        [gauge._address, gauge.methods.totalSupply().encodeABI()],
        [votingEscrow._address, votingEscrow.methods.locked__end(userAddress).encodeABI()],
    ]
    let aggcalls = await clean_and_multi_call(calls);
    let decoded = aggcalls[1].map(hex => web3.eth.abi.decodeParameter('uint256', hex))

    let period_timestamp = +decoded[Indexes.PERIOD_TIMESTAMP];
    let working_balances = +decoded[Indexes.WORKING_BALANCE];
    let working_supply = +decoded[Indexes.WORKING_SUPPLY];
    const userTimeLockEnd = +decoded[Indexes.TIME_LOCK_END];

    if (userTimeLockEnd === 0) return null;
    let timeLock = userTimeLockEnd - (Date.now() / 1000);
    if (estTimeLock) {
        timeLock = estTimeLock;
    }

    let L = +poolLiquidity

    let TOKENLESS_PRODUCTION = 40;

    let lim = +gaugeBalance * TOKENLESS_PRODUCTION / 100
    lim += L * myveSWRV / totalveSWRV * (100 - TOKENLESS_PRODUCTION) / 100;

    lim = Math.min(+gaugeBalance, lim)
    let old_bal = working_balances
    let noboost_lim = TOKENLESS_PRODUCTION * gaugeBalance / 100
    const displayBoost = working_balances / noboost_lim;
    const realBoost = (working_balances / working_supply) / (gaugeBalance / poolLiquidity);

    return [displayBoost, realBoost];
};
